type ApiMessage = {
  default_message?: boolean,
  error_code: number | null,
  msg: string,
}

export const commonMessages = {
  no_network: {
    error_code: 'PE01',
    msg:
`ネットワークに接続されていません
接続環境をご確認ください`,
  },
  network_timeout: {
    error_code: 'PE02',
    msg:
`通信に失敗しました
通信環境の良い場所でお試しください`,
  },
  maintenance: {
    error_code: 'PE03',
    msg:
`ただいまメンテナンス中です
ご不便をおかけしております
詳しくはメンテナンス情報をご確認ください`,
  },
  network_error: {
    error_code: 'PE04',
    msg: (status: string | number) => (
`HTTPステータス: ${status}
WEBサーバーが応答しませんでした
再度お試しください`
    ),
  },
}

export const errorDefaultMessage =
'エラーが発生しました'

const apiMessages: {[key: string]: ApiMessage} = {
  // デフォルトのメッセージ
  no_required_params: {
    default_message: true,
    error_code: 400,
    msg: '予期せぬエラーが発生しました',
  },
  unexpected_error: {
    default_message: true,
    error_code: 500,
    msg: errorDefaultMessage
  },
  no_response_code: {
    default_message: true,
    error_code: 0,
    msg: errorDefaultMessage
  },
  session_expired: {
    default_message: true,
    error_code: 501,
    msg:
`一定時間操作がなかったため
ログアウトしました
もう一度ログインしてください`
  },
  // 個別
  no_add_member_permission_401001: {
    error_code: 401001,
    msg: `メンバーを追加する権限がありません
工事の管理者に権限を付与するようご連絡ください`
  },
  no_add_member_permission_401004: {
    error_code: 401004,
    msg: `メンバーを追加する権限がありません
工事の管理者に権限を付与するようご連絡ください`
  },
  other_error: {
    error_code: null,
    msg: errorDefaultMessage
  },
}

export const apiMessageOf = (errorCode: number | null) => {
  const hitMessage = Object.values(apiMessages).find(m => m.error_code === errorCode);
  return hitMessage ? hitMessage.msg : errorDefaultMessage
}

export const apiDefaultDescriptions =
  Object.fromEntries(
    Object.values(apiMessages)
      .filter(m => m.default_message)
      .map(m => [ m.error_code, m.msg ])
  )
